/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import PresignUrlRepository from 'repositories/PresignUrlRepository';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import FetchHelpers from 'utils/FetchHelpers';

const initialState = {
  videoUploadingStatus: FETCH_STATUSES.idle,
  uploadProgress: 0,
  profileImageUploadingStatus: FETCH_STATUSES.idle,
  companyLogoImageUploadingStatus: FETCH_STATUSES.idle,
};

const firebaseSlice = createSlice({
  name: 'firebaseSlice',
  initialState,
  reducers: {
    uploadFileStart(state) {
      state.videoUploadingStatus = FETCH_STATUSES.pending;
    },
    uploadFileFail(state) {
      state.uploadProgress = 0;
      state.videoUploadingStatus = FETCH_STATUSES.failed;
    },
    uploadFileSuccess(state) {
      state.uploadProgress = 0;
      state.videoUploadingStatus = FETCH_STATUSES.fullfiled;
    },
    onFileUploadProgress(state, { payload }) {
      state.uploadProgress = payload;
    },
    uploadProfileImageStart(state) {
      state.profileImageUploadingStatus = FETCH_STATUSES.pending;
    },
    uploadProfileImageFail(state) {
      state.profileImageUploadingStatus = FETCH_STATUSES.failed;
    },
    uploadProfileImageSuccess(state) {
      state.profileImageUploadingStatus = FETCH_STATUSES.fulfilled;
    },
    uploadCompanyLogoStart(state) {
      state.companyLogoImageUploadingStatus = FETCH_STATUSES.pending;
    },
    uploadCompanyLogoFail(state) {
      state.companyLogoImageUploadingStatus = FETCH_STATUSES.failed;
    },
    uploadCompanyLogoSuccess(state) {
      state.companyLogoImageUploadingStatus = FETCH_STATUSES.fulfilled;
    },
  },
});

export const { actions } = firebaseSlice;

export default firebaseSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const onUploadProgress = progressEvent => {
    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    dispatch(actions.onFileUploadProgress(percentCompleted));
  };

  const uploadFileToS3 = async (attrs, blob) => {
    dispatch(actions.uploadFileStart());
    try {
      const {
        data: { url, fields },
      } = await PresignUrlRepository.get(attrs);

      const formData = FetchHelpers.toRawFormData(blob, fields);

      await FetchHelpers.postMultipartFormData(url, formData, { onUploadProgress });
      dispatch(actions.uploadFileSuccess());
      return fields;
    } catch (error) {
      dispatch(actions.uploadFileFail());
      return Promise.reject(error);
    }
  };

  const uploadProfileImageToS3 = async (attrs, blob) => {
    dispatch(actions.uploadProfileImageStart());
    try {
      const {
        data: { url, fields },
      } = await PresignUrlRepository.get(attrs);

      const formData = FetchHelpers.toRawFormData(blob, fields);

      await FetchHelpers.postMultipartFormData(url, formData);
      dispatch(actions.uploadProfileImageSuccess());
      return fields;
    } catch (error) {
      dispatch(actions.uploadProfileImageFail());
      return Promise.reject(error);
    }
  };

  const uploadCompanyLogoToS3 = async (attrs, blob) => {
    dispatch(actions.uploadCompanyLogoStart());
    try {
      const {
        data: { url, fields },
      } = await PresignUrlRepository.get(attrs);

      const formData = FetchHelpers.toRawFormData(blob, fields);

      await FetchHelpers.postMultipartFormData(url, formData);
      dispatch(actions.uploadCompanyLogoSuccess());
      return fields;
    } catch (error) {
      dispatch(actions.uploadCompanyLogoFail());
      return Promise.reject(error);
    }
  };

  return {
    uploadFileToS3,
    uploadProfileImageToS3,
    uploadCompanyLogoToS3,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/uploadFileSlice.js